module.exports = __webpack_public_path__ + "static/media/wisdom.74ad674e.mp4";